import SelectPatientLayout from 'presentation/doctor/layouts/AddSurgicalOrderNew/SelectPatient'
import React from 'react'

const SelectPatient = () => <SelectPatientLayout />

export default SelectPatient
